<template>
	<section :id="['container-' + index + '-' + multiData.type]" :class="['container-' + multiData.type]">
		<div class="container-xl">
			<div class="row">
				<h2>{{ multiData.config.title }}</h2>
				<template v-for="(section, name, index) in multiData.config" :key="index">
					<div :id="['container-' + section.type]" class="multiblock-element col-lg" :class="['container-' + section.type]" v-if="name !='title'">
						<FactsComponent :factsData="section" v-if="section.type == 'data' && section != ''" isMultiblock="true" />
						<FreetextComponent :freetextData="section" v-else-if="section.type == 'freeTexts' && section != ''" isMultiblock="true" />
						<GalleryComponent :pictureData="section" :index="index" :pictureKey="pictureKey" v-else-if="section.type == 'pictures' && section != ''" isMultiblock="true" />
						<TextComponent :textData="section" v-else-if="section.type == 'text' && section != ''" isMultiblock="true" />
					</div>
				</template>
			</div>
		</div>
	</section>
</template>

<script>

import FactsComponent from "./FactsComponent.vue";
import FreetextComponent from "./FreetextComponent.vue";
import GalleryComponent from "./GalleryItemComponent.vue";
import TextComponent from "./TextComponent.vue";

export default {
	components: {
		FactsComponent,
		FreetextComponent,
		GalleryComponent,
		TextComponent
	},
	props: {
		multiData: {
			type: Object
		},
		index: {
			type: Number
		},
		pictureKey: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/sectionComponent.scss";
</style>